module.exports = new __parcel__URL__("illustrationDarkForGa.ed39bdab.svg").toString();